// All these assets are added to this repo's media library: https://page-builder-assets.prismic.io/medias/
// You can then get the optimized (served via CDN) asset URLs by checking the assets API response in https://page-builder-assets.prismic.io/builder/pages/ZWjiRRAAACYAvGly?s=unclassified

export const whatsNewGifUrl =
  "https://page-builder-assets.cdn.prismic.io/page-builder-assets/af585a82-3d55-4d97-a2fe-c5ddb918a642_live+editing.gif"

export const simulatorSetupVideoUrl =
  "https://page-builder-assets.cdn.prismic.io/page-builder-assets/06fb1b24-e4cc-449f-ad12-6ddb15a6453d_liveeditingvideo.mp4"

export const simulatorScreenshotUrl =
  "https://images.prismic.io/page-builder-assets/492e3048-3023-4ea2-81fe-75f389fb22c0_simulator.jpg"

export const emptyMigrationReleasesUrl =
  "https://images.prismic.io/page-builder-assets/ZsdB_EaF0TcGJQcJ_empty-migration-releases.jpg"

export const emptyDocumentsList =
  "https://images.prismic.io/page-builder-assets/ZtXSkkaF0TcGJrhh_Illustrations-2-.jpg"

export const onboarding = {
  welcome:
    "https://images.prismic.io/page-builder-assets/ZurEs7VsGrYSvh3n_Illustrations.png",
  chooseLanguage:
    "https://images.prismic.io/page-builder-assets/ZxetyIF3NbkBX18j_Illustrations-2-.png",
  launchStarter:
    "https://images.prismic.io/page-builder-assets/ZvJ5oLVsGrYSv0N0_image-10-.png",
  pushModels:
    "https://images.prismic.io/page-builder-assets/ZvqihbVsGrYSwI7d_Illustrations-4-.png",
  createProject:
    "https://images.prismic.io/page-builder-assets/ZsdB_EaF0TcGJQcJ_empty-migration-releases.jpg",
  runSliceMachine:
    "https://images.prismic.io/page-builder-assets/ZvqihbVsGrYSwI7a_Illustrations-5-.png",
}
